import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMount } from "react-use";
import { useStores } from "../hooks";
import Header from "../component/Header";
import Footer from "../component/Footer";
import UserInfo from "../component/UserInfo";
import CountDown from "../component/CountDown";
import CustLendItems from "../component/CustLendItems";
import CustReserveItems from "../component/CustReserveItems";
import { getCustItem, procContinue } from "../service";
import { SlCustLendfileItem, SlCustReserveItem } from "../graphql";

const Cust = () => {
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  const [displayMod, setDisplayMod] = useState(0);
  const [continueMessage, setContinueMessage] = useState("");
  const [continueItem, setContinueItem] = useState<any>({});
  const [continueProcess, setContinueProcess] = useState(false);
  const [continueProcess2, setContinueProcess2] = useState(false);
  const [custLendfileItem, setCustLendfileItem] = useState<
    SlCustLendfileItem[]
  >([]);
  const [custReserveItem, setCustReserveItem] = useState<SlCustReserveItem[]>(
    []
  );

  useMount(() => {
    handleReload();
  });

  const handleDisplay = () => {
    setDisplayMod(displayMod === 1 ? 0 : 1);
  };

  const handleReload = () => {
    getCustItem().then((data) => {
      setCustLendfileItem(data.getCustLendfile.items);
      setCustReserveItem(data.getCustReserve.items);
    });
  };

  const handleSelect = (item: any) => {
    setContinueItem(item);
    setContinueProcess(true);
  };

  const handleContinueBook = () => {
    setContinueProcess2(true);
    if (continueItem.barcode !== undefined) {
      procContinue(continueItem.barcode)
        .then((res) => {
          if (res.success) {
            handleReload();
          }
          setContinueItem({});
          setContinueProcess(false);
          setContinueProcess2(false);
          setContinueMessage(res.message);
        })
        .catch((error) => {
          setContinueItem({});
          setContinueProcess(false);
          setContinueProcess2(false);
        });
    }
  };

  return (
    <>
      <div
        className="overlay"
        style={{ display: continueMessage ? "block" : "none" }}
      >
        <div className="info">
          <h4>{formatMessage({ id: "hyvendor.menu.renewed" })}</h4>
          <p className="warning">{continueMessage}</p>
          <div className="btns">
            <button
              type="button"
              className="btn confirm"
              onClick={(e) => {
                e.preventDefault();
                setContinueMessage("");
                setContinueItem({});
                setContinueProcess(false);
                setContinueProcess2(false);
              }}
            >
              {formatMessage({ id: "hyvendor.button.close" })}
            </button>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        style={{ display: continueProcess ? "block" : "none" }}
      >
        <div className="info">
          <h4>
            {formatMessage({ id: "hyvendor.menu.renew" })}
            <br />
            <span>{continueItem.title}</span>
          </h4>
          <p className="warning">
            {formatMessage({ id: "hyvendor.message.renew" })}
          </p>
          <div className="btns">
            <button
              type="button"
              className="btn confirm"
              disabled={continueProcess2}
              onClick={handleContinueBook}
            >
              {formatMessage({ id: "hyvendor.button.ok" })}
            </button>
            &nbsp;
            <button
              type="button"
              className="btn cancel"
              disabled={continueProcess2}
              onClick={(e) => {
                e.preventDefault();
                setContinueItem({});
                setContinueProcess(false);
                setContinueProcess2(false);
              }}
            >
              {formatMessage({ id: "hyvendor.button.cancel" })}
            </button>
          </div>
        </div>
      </div>
      <div className="page-set">
        <Header />
        <div className="Main">
          <UserInfo reader={sessionStore.userInfo} />
          <section className="Menu"></section>
          <h3 className="Title">
            {formatMessage({ id: "hyvendor.title.cust" })}
          </h3>
          <CountDown />
          <section className="history">
            {displayMod === 0 && (
              <CustLendItems
                items={custLendfileItem}
                handleSelect={handleSelect}
              />
            )}
            {displayMod === 1 && <CustReserveItems items={custReserveItem} />}
            <section className="btns">
              {displayMod === 1 && (
                <button
                  type="button"
                  className="btn next"
                  onClick={handleDisplay}
                >
                  {formatMessage({ id: "hyvendor.menu.loanlist" })}
                </button>
              )}
              {false &&
                displayMod === 0 && ( // 關掉功能
                  <button
                    type="button"
                    className="btn next"
                    onClick={handleDisplay}
                  >
                    {formatMessage({ id: "hyvendor.menu.reservedlist" })}
                  </button>
                )}
              &nbsp;
              <Link to="/logout">
                <button type="button" className="btn cancel">
                  {formatMessage({ id: "hyvendor.button.cancelexit" })}
                </button>
              </Link>
            </section>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Cust;
